var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { SimpleDialogModel } from "./SimpleDialogModel";
import { HXDesktopStudiesSearchType } from "./HXDesktopStudiesSearchViewModel";
import { NamedRoutes } from "./NamedRoutes";
import { UserType } from "healthex-common/user.dtos";
export class ResearchViewModel {
    constructor(container) {
        this.addProjectWizardDialog = new SimpleDialogModel();
        this.addProjectWizardConfirmCloseDialog = new SimpleDialogModel();
        this.showAdvancedSearch = false;
        this.studyManager = container.studyManager;
        this.authManager = container.authManager;
        this.appUIManager = container.appUIManager;
        this.addProjectRequirementsWizardUIManager = container.addProjectRequirementsWizardUIManager;
        this.routingUIManager = container.routingUIManager;
    }
    get showGoLiveChecklist() {
        return this.authManager.organizationIsLive === false && this.authManager.userType === UserType.EXTERNAL_RESEARCHER;
    }
    get showNotLiveCard() {
        return this.authManager.organizationIsLive === false && this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
    }
    setShowAdvancedSearch(showAdvancedSearch) {
        this.showAdvancedSearch = showAdvancedSearch;
    }
    get showCreateProjectButton() {
        return this.studyManager.canCreateStudy && this.authManager.organizationIsLive !== false;
    }
    get firstName() {
        return this.authManager.firstName;
    }
    get isHome() {
        return this.appUIManager.homepage === "PROJECTS";
    }
    get addProjectDialogTitleInfo() {
        return this.addProjectRequirementsWizardUIManager.dialogTitleInfo;
    }
    get defaultSearchType() {
        const researcher = this.authManager.isResearcher;
        return researcher ? HXDesktopStudiesSearchType.MY_PROJECTS : HXDesktopStudiesSearchType.OTHER_PROJECTS;
    }
    showAddProjectWizardDialog() {
        this.addProjectWizardDialog.show();
    }
    async closeAddProjectWizardDialog() {
        const currentPage = this.addProjectRequirementsWizardUIManager.currentPage;
        if (!currentPage)
            return;
        switch (currentPage) {
            case "WELCOME":
                this.addProjectWizardDialog.open = false;
                break;
            case "PROJECT_TYPE":
            case "LEGAL_NAME":
            case "STUDY_NAME":
            case "TEAM_MEMBERS":
            case "SUCCESS":
                await this.showAddProjectWizardConfirmCloseDialog();
                break;
        }
    }
    async showAddProjectWizardConfirmCloseDialog() {
        const confirmed = await this.addProjectWizardConfirmCloseDialog.showAndWait();
        this.addProjectWizardConfirmCloseDialog.open = false;
        if (confirmed)
            this.addProjectWizardDialog.open = false;
    }
    onStudiesSearchRowClick(info) {
        const { studyId, searchType } = info;
        if (searchType === HXDesktopStudiesSearchType.MY_PROJECTS) {
            this.routingUIManager.navigateTo(NamedRoutes.PROJECTS_PROJECT_MANAGER, { projectId: studyId });
        }
        else {
            this.routingUIManager.navigateTo(NamedRoutes.PROJECTS_OTHER_DETAILS, { projectId: studyId });
        }
    }
}
__decorate([
    observable
], ResearchViewModel.prototype, "showAdvancedSearch", void 0);
__decorate([
    computed
], ResearchViewModel.prototype, "showGoLiveChecklist", null);
__decorate([
    computed
], ResearchViewModel.prototype, "showNotLiveCard", null);
__decorate([
    computed
], ResearchViewModel.prototype, "showCreateProjectButton", null);
__decorate([
    computed
], ResearchViewModel.prototype, "firstName", null);
__decorate([
    computed
], ResearchViewModel.prototype, "isHome", null);
__decorate([
    computed
], ResearchViewModel.prototype, "addProjectDialogTitleInfo", null);
__decorate([
    computed
], ResearchViewModel.prototype, "defaultSearchType", null);
